<template>
  <el-button class="btn-confirm-next" @click="confirm()">{{value}}</el-button>
</template>

<script>
export default {
  name: "button-confirm-next",
  props: {
    value: {
      type: String,
      default: "确定"
    }
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    }
  }
};
</script>

<style scoped>
.btn-confirm-next {
  border: 1px solid #dcdfe6;
  color: #48576a;
  padding: 8px 16px;
  background-color: #f7f7f7;
  font-size: 13px;
}
.btn-confirm-next:hover {
  color: #1362ff;
  border: 1px solid #1362ff;
  background-color: #f7f7f7;
}
</style>



// WEBPACK FOOTER //
// src/components/Button/ButtonConfirmNext.vue